export default {
  number_trial_code: process.env.MIX_TFA_TOKEN_MAX_TRIAL_COUNT || 10,
  // 検索フロー (search flow)
  step_search1: 0,
  step_search2: 2,
  step_search3: 3,
  step_search4: 4,
  // 追加フロー (add flow)
  step_add1: 1,
  app_image: {
    logo_img_path: process.env.MIX_APP_LOGO_IMG_PATH,
    logo_header_img_path: process.env.MIX_APP_LOGO_HEADER_IMG_PATH,
  },
  member_avatar_default: '/images/member/icon-avatar-default.svg',
  mapbox_username: process.env.MIX_MAPBOX_USERNAME || '',
  mix_mapbox_token: process.env.MIX_MAPBOX_TOKEN || '',
  mix_max_attachment_size_mb: process.env.MIX_MAX_ATTACHMENT_SIZE_MB || 2,
  mix_max_customer_info_import_size_mb: process.env.MIX_MAX_CUSTOMER_INFO_IMPORT_SIZE_MB || 2,
  file_name_download_csv_customer_info: 'customer_info',
  file_name_download_template_import_customer: 'customer_import_template',
  file_name_download_template_import_center: '配送拠点取り込みテンプレート',
  file_name_download_template_import_transportation_result: '配送実績取り込みテンプレート',
  file_name_download_template_import_transport_instruction: '運送依頼情報取り込みテンプレート',
  file_name_download_template_import_shipment_instruction: '出荷依頼情報取り込みテンプレート',
  excel_mime_type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  mix_file_name_customer_management_table: process.env.MIX_FILE_NAME_CUSTOMER_MANAGEMENT_TABLE || '口数管理表',
  mix_file_name_number_management_output:
    process.env.MIX_FILE_NAME_NUMBER_MANAGEMENT_OUTPUT || 'number_management_output',
  mix_app_form_url: process.env.MIX_APP_FORM_URL,
  mix_limit_customer_attachment_file: process.env.MIX_LIMIT_CUSTOMER_ATTACHMENT_FILE || 5,
  mix_center_emission_filename: process.env.MIX_CENTER_EMISSION_FILENAME || 'CO2の排出量',
  mix_max_center_emission_import_size_mb: process.env.MIX_MAX_CENTER_EMISSION_IMPORT_SIZE_MB || 2,
  default_max_chart_scale: 100,
  forest_management_export_file_name: 'forest_management',
  default_coefficient_setting_modal: {
    certification_period: [
      {
        title: '認証対象期間',
        cost: 16,
        is_flag: true,
        unit: '年',
      },
    ],
  },
}
